import { render, staticRenderFns } from "./PhotoThumbnail.vue?vue&type=template&id=1c807ee8&scoped=true"
import script from "./PhotoThumbnail.vue?vue&type=script&lang=js"
export * from "./PhotoThumbnail.vue?vue&type=script&lang=js"
import style0 from "./PhotoThumbnail.vue?vue&type=style&index=0&id=1c807ee8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c807ee8",
  null
  
)

export default component.exports